// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39HX9","name":"Header_name__bPoFW","birthday":"Header_birthday__1bIqR","skeleton":"Header_skeleton__1G3jk"};